import * as React from 'react'

const SvgChipCard = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.35}
      d='M23.75 5H20l-1.225 2.5L17.5 5h-5l-1.36 2.5L10 5H6.25A3.75 3.75 0 0 0 2.5 8.75v2.5L5 12.5l-2.5 1.25v2.5L5 17.5l-2.5 1.25v2.5A3.75 3.75 0 0 0 6.25 25H10l1.226-2.5L12.5 25h5l1.245-2.5L20 25h3.75a3.75 3.75 0 0 0 3.75-3.75v-2.5L25 17.5l2.5-1.25v-2.5L25 12.5l2.5-1.25v-2.5A3.75 3.75 0 0 0 23.75 5Z'
      fill='#101AA1'
    />
    <path
      d='M27.5 11.25h-6.014A7.6 7.6 0 0 0 20 9.439V5h-2.5v5.027c0 .392.184.762.496.998C19.27 11.988 20 13.436 20 15s-.73 3.012-2.004 3.975a1.25 1.25 0 0 0-.496.997V25H20v-4.439a7.552 7.552 0 0 0 1.486-1.811H27.5v-2.5h-5.115c.07-.41.115-.825.115-1.25 0-.425-.045-.84-.115-1.25H27.5v-2.5ZM10 9.439a7.6 7.6 0 0 0-1.486 1.811H2.5v2.5h5.115c-.07.41-.115.825-.115 1.25 0 .425.045.84.115 1.25H2.5v2.5h6.014A7.6 7.6 0 0 0 10 20.561V25h2.5v-5.027c0-.392-.184-.762-.496-.998C10.73 18.012 10 16.564 10 15s.73-3.012 2.004-3.975a1.25 1.25 0 0 0 .496-.998V5H10v4.439Z'
      fill='#101AA1'
    />
  </svg>
)

export default SvgChipCard
